// extracted by mini-css-extract-plugin
module.exports = {"root":"DragIcon_root__gT0I9"};